import loadLiff from "./authen/load_liff.js"
import * as subscription_form_functions from "./subscription_form.js"
const { 
  setSelectedIndexForToday,
  setSelectedIndexForYear,
  resetOptionSelectDayFor,
  resetYearList,
  setupToggleUnknownBirthTime
} = subscription_form_functions

function getAccessTokenFromCookie() {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("line_lagnara="))
    ?.split("=")[1]
}

document.addEventListener("turbo:load", function () {
  const signupPage = document.getElementById("subscription-signup")
  if (signupPage != null) {
    // สมัครผ่าน Google/LINE บนเว็บ → ข้ามส่วน LIFF ทั้งหมด (meta liffid มีใน layout เสมอ เลยดูจาก data attribute)
    const oauthSignup = signupPage.dataset.oauthSignup === "true"
    const liffMeta = document.getElementById("liffid")
    if (!oauthSignup && liffMeta != null) {
      loadLiff().then((liff) => liff.init({
        liffId: liffMeta.content,
      })
      .then(async () => {
        if (!liff.isLoggedIn()) {
          // ห้าม liff.login() จากหน้านี้ — redirect_uri (/subscriptions/sign_up) อยู่นอก LIFF endpoint
          // LINE จะตอบ 400 Bad Request; ส่งกลับไปให้ /liff (endpoint) ทำ login แล้วเด้งกลับมาเอง
          window.location.href = "/liff?redirect=" + encodeURIComponent("/subscriptions/sign_up")
          return
        }
        let accessToken = await liff.getAccessToken()
        // max-age 30 วันเท่ากับใน authen/liff.js — ไม่ตั้งแล้วคุกกี้หายตอนปิดเบราว์เซอร์
        document.cookie = `line_lagnara=${accessToken}; path=/; max-age=${30 * 24 * 60 * 60}`

        // ทักทายด้วยชื่อ/รูป LINE ให้รู้ว่า authorize สำเร็จและหน้านี้ต่อเนื่องกัน
        try {
          const profile = await liff.getProfile()
          const nameSpan = document.getElementById("signup-line-name")
          if (nameSpan && profile.displayName) {
            const prefix = nameSpan.parentElement.dataset.namePrefix ?? "คุณ "
            nameSpan.textContent = `${prefix}${profile.displayName}`
          }
          const avatar = document.getElementById("signup-line-avatar")
          if (avatar && profile.pictureUrl) {
            avatar.src = profile.pictureUrl
            avatar.classList.remove("hidden")
          }
        } catch (e) {
          // ดึงโปรไฟล์ไม่ได้ → คงคำทักทายกลางๆ ไว้ ฟอร์มใช้งานได้ปกติ
        }
      }))

      const accessToken = getAccessTokenFromCookie()
      const inputLineAccessToken = document.querySelector("#subscription-signup #subscription_access_token")
      if (inputLineAccessToken) {
        inputLineAccessToken.value = accessToken
      }
    }

    // หน้าต้อนรับ → กด CTA ค่อยเปิดฟอร์มวันเกิด
    const startBtn = document.getElementById("signup-start")
    if (startBtn) {
      startBtn.addEventListener("click", () => {
        document.getElementById("signup-welcome").classList.add("hidden")
        document.getElementById("signup-form-panel").classList.remove("hidden")
        window.scrollTo({ top: 0, behavior: "smooth" })
      })
    }

    // วันเกิดไม่มีค่าเริ่มต้น — เคย default เป็น "วันนี้/ปีนี้" กดผ่านเร็ว ๆ ได้ลัคนาผิดทันที
    // ต้องเลือกเองทั้ง 3 ช่อง (required เดิมกันส่งฟอร์มว่างอยู่แล้ว)
    // ค่าที่เคยกรอก (ฟอร์มเด้งกลับจาก validation) เติมกลับผ่าน data-birth-*
    const selectTagDay = document.querySelector(`select#day`)
    const selectTagMonth = document.querySelector(`select#month`)
    const selectYear = document.getElementById("year")
    const prior = {
      day: selectTagDay.dataset.birthDay,
      month: selectTagMonth.dataset.birthMonth,
      year: selectYear.dataset.birthYear,
    }
    const addPlaceholder = (select, label) => {
      if (select.querySelector('option[value=""]')) return
      const opt = document.createElement("option")
      opt.value = ""
      opt.textContent = label
      opt.disabled = true
      opt.hidden = true
      select.prepend(opt)
      select.value = ""
    }

    // จำนวนวันของเดือนต้องคิดจากปีเกิดที่เลือก — เดิมใช้ปีปัจจุบัน ปีนี้ไม่ใช่ปีอธิกสุรทินเลยเลือก 29 ก.พ. ไม่ได้
    // ยังไม่เลือกปี = ใช้ปีอธิกสุรทิน (2000) ไว้ก่อน ให้ 29 ก.พ. โผล่ แล้วค่อยตัดตอนเลือกปี
    const dayListYear = () => parseInt(selectYear.value, 10) || 2000
    const refreshDays = () => {
      const dayNotChosen = selectTagDay.value === ""
      resetOptionSelectDayFor(selectTagMonth.value || 1, dayListYear())
      if (dayNotChosen) addPlaceholder(selectTagDay, selectTagDay.dataset.placeholder)
    }
    selectTagMonth.addEventListener("change", refreshDays)

    if (prior.month) selectTagMonth.value = prior.month
    else addPlaceholder(selectTagMonth, selectTagMonth.dataset.placeholder)

    resetOptionSelectDayFor(prior.month || 1, parseInt(prior.year, 10) || 2000)
    if (prior.day) selectTagDay.value = prior.day
    else addPlaceholder(selectTagDay, selectTagDay.dataset.placeholder)

    // Handle year era toggle — ไทยเริ่ม พ.ศ. · ภาษาอื่น ค.ศ. (ตัวเลือกซ่อนอยู่) ดู data-default-era ใน _form
    const defaultEra = document.getElementById("era-choice")?.dataset.defaultEra || "buddhist"
    document.getElementById(defaultEra === "christian" ? "christian-era" : "buddhist-era").checked = true
    const eraRadios = document.querySelectorAll('input[name="format_year"]')
    let selectedYear = prior.year || ""
    resetYearList(defaultEra)
    if (prior.year) selectYear.value = prior.year
    else addPlaceholder(selectYear, selectYear.dataset.placeholder)

    eraRadios.forEach((radio) => {
      radio.addEventListener("click", (e) => {
        resetYearList(e.target.value)
        if (selectedYear) selectYear.value = selectedYear
        else addPlaceholder(selectYear, selectYear.dataset.placeholder)
      })
    })

    selectYear.addEventListener("change", (e) => {
      selectedYear = e.target.value
      refreshDays()
    })

    // เวลาเกิด/จังหวัด/เพศ ก็ต้องเติมคืนตอนฟอร์มเด้งกลับด้วย — เดิมเติมแค่วัน/เดือน/ปี
    // ที่เหลือรีเซ็ตหมด คนต้องนั่งเลือกใหม่ (data-* ฝั่ง view มีอยู่แล้ว แค่ไม่มีใครอ่าน)
    ;[
      [document.getElementById("hour"), "birthHour"],
      [document.getElementById("minute"), "birthMinute"],
      [document.getElementById("province"), "birthPlace"],
      [document.getElementById("gender"), "gender"],
    ].forEach(([select, key]) => {
      if (select && select.dataset[key]) select.value = select.dataset[key]
    })

    // Handle unknown birth time
    setupToggleUnknownBirthTime()
  }
})
